const ZERO_WIDTH_SPACE = '\u200B';

/**
 * Insert wrap opportunities so long labels can break in CSS (`break-words`).
 * Breaks after space (and other `breakChars`, default `_` and `-`) and every
 * `every` consecutive characters that have no natural break.
 */
export function softWrap(text, every = 20, breakChars = ' _-') {
  if (text == null || text === '') return '';
  const s = String(text);
  const breaks = new Set([...String(breakChars)]);
  const maxRun = Number(every);
  let out = '';
  let run = 0;
  for (let i = 0; i < s.length; i += 1) {
    const ch = s[i];
    out += ch;
    if (breaks.has(ch)) {
      out += ZERO_WIDTH_SPACE;
      run = 0;
    } else {
      run += 1;
      if (maxRun > 0 && run >= maxRun) {
        out += ZERO_WIDTH_SPACE;
        run = 0;
      }
    }
  }
  return out;
}
